import { render } from "./sendNotificationAndPushNotificationWidget.vue?vue&type=template&id=b4595574"
import script from "./sendNotificationAndPushNotificationWidget.vue?vue&type=script&lang=js"
export * from "./sendNotificationAndPushNotificationWidget.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__